import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowWallRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowWallRight"><Path d="M12.75 7.25L17.5 12L12.75 16.75" stroke="currentColor" strokeLinecap="square"/><Path d="M2.5 12H16.75" stroke="currentColor" strokeLinecap="square"/><Path d="M21.5 4.5V19.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowWallRight;
